// import moment from 'moment'

// export default ({ lowerValue, upperValue }) => (
export default () => false
// moment(lowerValue).isAfter(upperValue)
